import { render } from "./NotificationMailBody.vue?vue&type=template&id=d605d0a2&scoped=true"
import script from "./NotificationMailBody.vue?vue&type=script&lang=js"
export * from "./NotificationMailBody.vue?vue&type=script&lang=js"

import "./NotificationMailBody.vue?vue&type=style&index=0&id=d605d0a2&scoped=true&lang=css"

import exportComponent from "C:\\Apps\\AppBase\\app-base-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d605d0a2"]])

export default __exports__